'use strict';

import { addSeconds } from 'date-fns';

import zonedDate from './zoned-date';

export function getCookie(name) {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');

        if (decodeURIComponent(cookie[0].trim()) === name) {
            return cookie.length ? decodeURIComponent(cookie[1]) : '';
        }
    }

    return undefined;
}

export function setCookie(name, value, options) {
    let cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    if (options && (options instanceof Date || typeof options === 'number')) {
        options = {
            expires: options,
        }
    }

    if (options && typeof options === 'object') {
        if (options.expires && options.expires instanceof Date) {
            cookie += '; expires=' + options.expires.toGMTString();
        } else if (options.expires) {
            const expires = parseInt(options.expires, 10);

            if (expires) {
                cookie += '; expires=' + addSeconds(zonedDate(), expires).toGMTString();
            }
        }

        if (options.path) {
            cookie += '; path=' + options.path.toString();
        } else {
            cookie += '; path=/;';
        }

        if (options.domain) {
            cookie += '; domain=' + options.domain.toString();
        }

        if (options.secure) {
            cookie += '; secure';
        }
    } else {
        cookie += '; path=/;';
    }

    document.cookie = cookie;
}

export function removeCookie(name) {
    setCookie(name, '', {
        expires: 0,
    });
}

export default {
    get: getCookie,
    set: setCookie,
    remove: removeCookie,
}
